import { marketingColors } from "../../app/components/tickitMarketingTheme";
import { getBrandingColors } from "./brandingUtils";

/** Shared spacing, typography, and surface styles for registration templates. */
export const layout = {
  pagePx: { xs: 2, sm: 3 },
  pagePy: { xs: 3, md: 5 },
  cardRadius: 3,
  cardPadding: { xs: 2, sm: 2.5, md: 3.5 },
  sectionGap: 2.5,
  headline: {
    fontWeight: 800,
    fontSize: { xs: "1.5rem", sm: "1.75rem", md: "2rem" },
    lineHeight: 1.2,
  },
  subtitle: {
    fontSize: { xs: "0.95rem", sm: "1.05rem" },
    lineHeight: 1.5,
    mt: 0.75,
  },
  logo: {
    maxHeight: { xs: 48, sm: 56, md: 64 },
    maxWidth: { xs: 160, sm: 180, md: 200 },
    mb: 2,
    objectFit: "contain",
  },
  footer: {
    textAlign: "center",
    mt: { xs: 2, sm: 3 },
    px: 2,
    fontSize: "0.875rem",
    lineHeight: 1.6,
    opacity: 0.75,
  },
};

export function cardSx(branding = {}, extra = {}) {
  const { accent } = getBrandingColors(branding);
  return {
    borderRadius: layout.cardRadius,
    border: `1px solid ${accent}22`,
    bgcolor: "#fff",
    overflow: "hidden",
    ...extra,
  };
}

export function sectionBorderSx(branding = {}) {
  const { accent } = getBrandingColors(branding);
  return { border: `1px solid ${accent}33` };
}

export function pageBgSx() {
  return { minHeight: "100vh", bgcolor: marketingColors.gray50 };
}
